import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

import CountryField from "../CountryField";

import i18n from '../../i18n';

export default function Form(props) {
  const {
    handleSubmitEvent,
    updateInputState,
    formInputs
  } = props;

  const { certificateType, country } = formInputs;

  const {
    handleSubmit,
    register,
    errors,
    control,
  } = useForm();

  return (
    <form onSubmit={handleSubmit(handleSubmitEvent)} noValidate>
      <section className="row title-page">
        <div className="col-sm-12">
          <h1>{i18n.t("certification.form.application")}</h1>
        </div>
      </section>

      <section className="row">
        <div className="col-sm-12 col-md-3 first-col">
          <div className="custom-control custom-radio">
            <input
              className="custom-control-input"
              type="radio"
              value="renewal"
              name="certificateType"
              id="certificateTypeRenewal"
              onChange={updateInputState}
              checked={certificateType === "renewal"}
              ref={register({ required: "Required" })}
              className={`custom-control-input ${
                errors.certificateType ? "is-invalid" : null
              }`}
            />
            <label
              htmlFor="certificateTypeRenewal"
              className="custom-control-label"
            >
              {i18n.t("certification.form.isUpdate")}
            </label>
          </div>

          <div className="custom-control custom-radio">
            <input
              className={`custom-control-input ${
                errors.certificateType ? "is-invalid" : null
              }`}
              type="radio"
              value="new"
              name="certificateType"
              id="certificateTypeNew"
              onChange={updateInputState}
              checked={certificateType === "new"}
              ref={register({ required: "Required" })}
            />
            <label
              htmlFor="certificateTypeNew"
              className="custom-control-label"
            >
              {i18n.t("certification.form.isNew")}
            </label>
          </div>
        </div>
        
        <div className="col-sm-12 col-md-1 d-none d-md-flex">
          <div className="divider"></div>
        </div>
        <div className="col-sm-12 col-md-5 second-col">
          <CountryField
            updateInputState={updateInputState}
            country={country}
            errors={errors}
            control={control}
            label={i18n.t("certification.form.country")}
            fieldName='country'
            placeholder={i18n.t("certification.form.selectCountry")}
            fieldId="country-field"
          />
          <button type="submit" className="btn btn-outline-primary">
              {i18n.t("certification.form.go")}
          </button>
        </div>
      </section>
    </form>
  );
};
